<div
  class="w-[380px] max-h-[440px] flex flex-col bg-surface border border-line rounded-md shadow-lift overflow-hidden"
>
  <div class="flex items-center justify-between px-3.5 py-3 border-b border-line-subtle flex-none">
    <h3 class="header-panel m-0 text-[13px] font-extrabold">Notifications</h3>
    @if (notifications().length) {
      <button
        data-testid="notification-mark-all-read-btn"
        nz-button
        nzType="link"
        nzSize="small"
        class="!px-0 !h-auto text-[11.5px] font-bold"
        (click)="markAllRead()"
      >
        Mark all read
      </button>
    }
  </div>

  <div #listEl class="relative flex-1 min-h-0 overflow-y-auto" (scroll)="onListScroll($event)">
    @if (pending().length) {
      <div class="sticky top-2 z-[2] flex justify-center h-0">
        <button
          data-testid="notification-show-new-btn"
          type="button"
          class="h-[26px] px-3 rounded-full border-0 bg-accent text-accent-contrast text-[11.5px] font-bold cursor-pointer shadow-lift"
          (click)="showPending()"
        >
          {{
            pending().length === 1 ? '1 new notification' : pending().length + ' new notifications'
          }}
        </button>
      </div>
    }
    <nz-spin [nzSpinning]="isInitialLoading()">
      @if (!isInitialLoading() && notifications().length === 0) {
        <div class="py-8">
          <app-table-states
            emptyTitle="You're all caught up"
            emptyHint="New notifications show up here"
          />
        </div>
      } @else {
        @for (n of notifications(); track n.id) {
          <div
            [attr.data-testid]="'notification-row-' + n.id"
            class="flex gap-2.5 px-3.5 py-[11px] border-b border-line-subtle last:border-b-0 cursor-pointer hover:bg-surface-2 transition-colors"
            [class.row-fresh]="isFresh(n.id)"
            tabindex="0"
            role="button"
            (click)="onRowClick(n)"
            (keydown.enter)="onRowClick(n)"
          >
            <div class="w-2 pt-[5px] flex-none">
              @if (!n.isRead) {
                <span class="block w-[7px] h-[7px] rounded-full bg-accent"></span>
              }
            </div>
            <div class="min-w-0 flex-1">
              <div class="flex items-center gap-1.5 mb-0.5 flex-wrap">
                <span
                  class="text-[12.5px] truncate"
                  [class]="n.isRead ? 'font-medium text-ink-2' : 'font-bold text-ink'"
                >
                  {{ view(n).title }}
                </span>
                <app-status-pill [label]="n.severity" [tone]="tone(n)" />
                @if (isResolved(n)) {
                  <app-status-pill label="Resolved" tone="neutral" />
                }
              </div>
              <div
                class="text-[11.5px] truncate"
                [class]="n.isRead ? 'text-ink-muted' : 'text-ink-2'"
              >
                {{ view(n).detail }}
              </div>
              <div class="text-[10.5px] font-mono text-ink-muted mt-1">
                {{ n.createdAt | timeAgo }}
              </div>
            </div>
            @if (isNavigable(n)) {
              <nz-icon nzType="right" class="!text-[11px] text-ink-muted flex-none self-center" />
            }
          </div>
        }
        @if (isLoadingMore()) {
          <div class="flex justify-center py-3">
            <nz-spin nzSimple nzSize="small" />
          </div>
        }
      }
    </nz-spin>
  </div>

  @if (realtime.paused()) {
    <div
      class="flex-none flex items-center gap-2 px-3.5 py-2 border-t border-line-subtle bg-warn-soft text-warn-ink text-[11.5px] font-semibold"
      role="status"
    >
      <nz-spin nzSimple nzSize="small" />
      <span>Live updates paused — reconnecting…</span>
    </div>
  } @else if (realtime.caughtUp()) {
    <div
      class="flex-none px-3.5 py-2 border-t border-line-subtle bg-ok-soft text-ok-ink text-[11.5px] font-semibold"
      role="status"
    >
      Reconnected — caught up
    </div>
  }
</div>
